import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../typesNew";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => {
  if (state && state.userState) {
    return state.userState;
  } else {
    return initialState;
  }
};

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading
);
export const selectFormData = createSelector(
  [selectDomain],
  (state) => state.formData
);
export const selectList = createSelector([selectDomain], (state) => state.list);
export const selectSearch = createSelector(
  [selectDomain],
  (state) => state.search
);
export const selectPageNo = createSelector(
  [selectDomain],
  (state) => state.pageNo
);
export const selectPageSize = createSelector(
  [selectDomain],
  (state) => state.pageSize
);
export const selectTotalRow = createSelector(
  [selectDomain],
  (state) => state.totalRow
);

export const selectOrderBy = createSelector(
  [selectDomain],
  (state) => state.orderBy
);
export const selectOrderDir = createSelector(
  [selectDomain],
  (state) => state.orderDir
);

export const selectToggleLoading = createSelector(
  [selectDomain],
  (state) => state.toggleLoading
);
export const selectOrderPageNo = createSelector(
  [selectDomain],
  (state) => state.orderPageNo
);
export const selectOrderPageSize = createSelector(
  [selectDomain],
  (state) => state.orderPageSize
);
export const selectOrderTotalRow = createSelector(
  [selectDomain],
  (state) => state.orderTotalRow
);
export const selectOrder = createSelector(
  [selectDomain],
  (state) => state.orders
);

export const selectStartDate = createSelector(
  [selectDomain],
  (state) => state.startDate
);
export const selectEndDate = createSelector(
  [selectDomain],
  (state) => state.endDate
);